import { getPrice } from "@/lib/strapi";
import { ArrowRight, Phone } from "lucide-react";
import Link from "next/link";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Solitreo } from "next/font/google";

interface ClientProps {
  solution: any;
}

export function SolutionCard({ solution }: ClientProps) {
  return (
    <div
      key={solution.slug}
      className="bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-lg transition-all duration-300"
    >
    <div className="relative overflow-hidden h-[260px]">
        <img
          src={solution?.image?.medium}
          alt={solution.name}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-6">
        <h3 className="font-bold text-foreground mb-2">{solution.name}</h3>
        <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
          {solution.description}
        </p>
        <div className="flex flex-wrap gap-1.5 mb-4">
          {solution.tags.slice(0, 3).map((tag: string) => (
            <span
              key={`product-${solution.slug}-tags-${tag}`}
              className="text-xs font-medium px-2.5 py-0.5 rounded-full border bg-blue-50 text-blue-700 border-blue-200"
            >
              {tag}
            </span>
          ))}
        </div>
        <Button
          asChild
          variant="ghost"
          size="sm"
          className="text-primary hover:bg-primary -ml-2"
        >
          <Link href={`/giai-phap/${solution.slug}`}>
            Xem Chi Tiết <ArrowRight className="ml-1 h-3 w-3" />
          </Link>
        </Button>
      </div>
    </div>
  );
}
